import React from 'react';
import { ReactComponent as LikesIcon } from '../../../../images/v2/responseList/ThumbsUp.svg';
import { ReactComponent as DislikesIcon } from '../../../../images/v2/responseList/ThumbsDown.svg';
import { ReactComponent as CommentsIcon } from '../../../../images/v2/responseList/comments.svg';
import './EptFeedback.css';
import { EptFeedbackProps } from '../types';

// Icon mapping for sub-keys
const getIconComponent = (id: string): React.ComponentType<any> | null => {
  switch (id) {
    case 'likes':
      return LikesIcon;
    case 'dislikes':
      return DislikesIcon;
    case 'comments':
      return CommentsIcon;
    default:
      return null;
  }
};

const EptFeedback: React.FC<EptFeedbackProps> = ({
  column,
  data,
  label,
  value,
}) => {
  // Legacy support for old interface
  if (label && value !== undefined) {
    return (
      <div className="ept-feedback">
        {label === 'Likes' && <LikesIcon />}
        {label === 'Dislikes' && <DislikesIcon />}
        {label === 'Comments' && <CommentsIcon />}
        <span className="ept-feedback-value">{value}</span>
      </div>
    );
  }

  // New interface with column configuration and row data
  if (!column || !column.sub_keys || !data) {
    return null;
  }

  const isIconOnly = column.display_mode === 'iconOnly';
  const isHorizontal = column.item_order === 'horizontal';

  return (
    <div
      className={`ept-feedback-container ${isHorizontal ? 'horizontal' : 'vertical'}`}
    >
      {column.sub_keys.map((subKey, index) => {
        const IconComponent = getIconComponent(subKey.id);
        const count = data[subKey.key] || 0;

        return (
          <div key={index} className="ept-feedback-item">
            {IconComponent && <IconComponent className="feedback-icon" />}
            {(!isIconOnly || subKey.show_count) && (
              <span className="ept-feedback-value">{count}</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default EptFeedback;
